<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}
.history {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182eb;
  line-height: 20px;
  height: 25px;
  cursor: pointer;
  margin-top: 40px;
}
.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}
.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;
  > div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }
  > div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }
}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}
// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}
.cust-mes {
  margin: 0px 0px 14px 18px;
}
.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}
.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}
.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="flex">
      <div class="title-div">用户信息</div>
      <!-- <div class="history" @click="openHistorydig(false)">历史信息</div> -->
    </div>
    <el-table
      class="el-table"
      :data="tableData"
      border
      max-height="200px"
      style="width: 100%; margin: 20px auto"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{
        background: '#FAFAFA',
        color: '#8F9BB3',
        fontSize: '14px',
        textAlign: 'center',
        border: '1px solid #F0F0F0',
      }"
    >
      <el-table-column align="center" prop="deviceCode" label="充电桩IMEI编号" />
      <el-table-column align="center" prop="custMobile" label="用户手机号" />
      <el-table-column align="center" prop="bindStatus" label="状态">
        <template><span>已绑定</span></template>
      </el-table-column>
      <el-table-column align="center" prop="bindTime" label="绑定时间" />
    </el-table>
    <el-dialog :visible.sync="historyDialogVisible">
      <div class="phone">
        <el-table
          class="el-table"
          :data="tableData"
          border
          max-height="200px"
          style="width: 100%; margin: 20px auto"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{
            background: '#FAFAFA',
            color: '#8F9BB3',
            fontSize: '14px',
            textAlign: 'center',
            border: '1px solid #F0F0F0',
          }"
        >
          <el-table-column prop="pileCode" label="共享开关设备编号" />
          <el-table-column prop="mobile" label="用户手机号" />
          <el-table-column prop="content" label="状态" />
          <el-table-column prop="lastModifiedWhen" label="绑定时间" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [],
      pagination: pageConfig.detailPagination,
      custInfo: {},
      queryInfo: {}, // 默认内容
      historyDialogVisible: false,
    };
  },
  methods: {
    init() {
      let _ = this;
      const list = _.$store.state.pileObj
      if (list) {
        _.queryInfo.deviceCode = list.deviceCode;
        _.getFormInfo();
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this;
      _.$H.post(_, _.$A.digitization.getShareDeviceCustInfo, _.queryInfo).then((res) => {
        _.tableData = res.data.data || []
      });
    },
    // 获取表单信息
    openHistorydig(flag) {
      let _ = this;
      _.$H
        .post(_, _.$A.pile.listHirtoryRelation, {
          pileCode: _.pileCode,
          custType: flag ? "亲友" : "桩主",
        })
        .then((res) => {
          this.flag = flag;
          _.detailForm.relHistoryList = res.data.data;
          _.historyDialogVisible = true;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
